import React, { useEffect, useState } from 'react'
import styles from './ThreeDimensionSection.module.sass'
import { EditableDescription, EditableTitle, WContainer, WImage } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { Close } from '@components/icons'
import ThreeDimensionModal from '@components/atoms/ThreeDimensionModal/ThreeDimensionModal'
import { MenuItemType } from '@utils/types'

interface Props {
  className?: string
  item?: MenuItemType
}

const ThreeDimensionSection = (props: Props) => {
  const { className = '', item = undefined } = props

  const [activeModal, setActiveModal] = useState<number | null>(null)

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        setActiveModal(null)
      }
    }
    document.addEventListener('keydown', keyDownHandler)
    return () => document.removeEventListener('keydown', keyDownHandler)
  }, [])

  const toggleModalVisibility = (modalNumber: number) => {
    setActiveModal((prevActiveModal) => (prevActiveModal === modalNumber ? null : modalNumber))
  }

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.main}>
            <EditableTitle variant="h2" title={t('Batteria')} className={styles.title} />
            {/* <EditableDescription
              description={t('BatteriaDescription')}
              className={styles.description}
            /> */}
          </div>

          <div className={styles.imageBox}>
            <div className={styles.imageWrapper}>
              <WImage maxWidth={648} maxHeight={500} src={'/3dImage.png'} staticMedia={true} />
              <button className={styles.first} onClick={() => toggleModalVisibility(1)}>
                {activeModal !== 1 ? (
                  <span className={styles.innerPin} />
                ) : (
                  <Close className={styles.closeIcon} />
                )}
              </button>
              <ThreeDimensionModal
                isOpen={activeModal === 1}
                onClose={() => toggleModalVisibility(1)}
                title={t('title_pin_1')}
                description={t('description_pin_1')}
                className={styles.firstModal}
              />

              <button className={styles.second} onClick={() => toggleModalVisibility(2)}>
                {activeModal !== 2 ? (
                  <span className={styles.innerPin} />
                ) : (
                  <Close className={styles.closeIcon} />
                )}
              </button>
              <ThreeDimensionModal
                isOpen={activeModal === 2}
                onClose={() => toggleModalVisibility(2)}
                title={t('title_pin_2')}
                description={t('description_pin_2')}
                className={styles.modalSecond}
              />

              <button className={styles.third} onClick={() => toggleModalVisibility(3)}>
                {activeModal !== 3 ? (
                  <span className={styles.innerPin} />
                ) : (
                  <Close className={styles.closeIcon} />
                )}
              </button>
              <ThreeDimensionModal
                isOpen={activeModal === 3}
                onClose={() => toggleModalVisibility(3)}
                title={t('title_pin_3')}
                description={t('description_pin_3')}
                className={styles.modalThird}
              />

              <button className={styles.fourth} onClick={() => toggleModalVisibility(4)}>
                {activeModal !== 4 ? (
                  <span className={styles.innerPin} />
                ) : (
                  <Close className={styles.closeIcon} />
                )}
              </button>
              <ThreeDimensionModal
                isOpen={activeModal === 4}
                onClose={() => toggleModalVisibility(4)}
                title={t('title_pin_4')}
                description={t('description_pin_4')}
                className={styles.modalFourth}
              />
            </div>
          </div>
        </div>
      </WContainer>
    </div>
  )
}

export default ThreeDimensionSection
